import { render } from "./MaleUsersPage.vue?vue&type=template&id=0b34081c&scoped=true"
import script from "./MaleUsersPage.vue?vue&type=script&lang=js"
export * from "./MaleUsersPage.vue?vue&type=script&lang=js"

import "./MaleUsersPage.vue?vue&type=style&index=0&id=0b34081c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0b34081c"

export default script